/**
 * Form Tracking Alpine.js Component
 * Handles dataLayer events for Freeform form submissions
 */

export const trackFormSubmission = ({ formType, brandHandle = 'unknown', pageTitle = 'unknown' }) => {
  // Ensure dataLayer exists
  if (!window.dataLayer) {
    window.dataLayer = []
  }

  // Determine form_name based on form type
  const formName = formType === 'contact' ? 'contact_us' : 'product_rfi'

  // Prepare dataLayer event
  const eventData = {
    event: 'generate_lead',
    currency: 'USD',
    value: 0,
    lead_source: brandHandle + ' - ' + pageTitle + ' - ' + formName,
    items: [
      {
        google_business_vertical: 'custom',
        id: null,
        location_id: brandHandle,
        slug: formName, // Using form_name as slug as requested
        business_line: pageTitle,
        parent_category: null,
        category: null,
      },
    ],
  }

  // Push to dataLayer
  window.dataLayer.push(eventData)
}

export default ({ formType, brandHandle = 'unknown', pageTitle = 'unknown' }) => ({
  init() {
    // Wait for the form to be ready
    this.$nextTick(() => {
      this.setupFormTracking()
    })
  },

  setupFormTracking() {
    const container = this.$el

    // Find the actual Freeform form within the container
    const form = container.querySelector('form[data-freeform]')

    if (!form) {
      return
    }

    // Enable AJAX for reliable tracking
    form.addEventListener('freeform-ready', function (event) {
      event.options.ajax = true

      // Prevent duplicate success messages by intercepting the success handler.
      // Duplicate messages are caused by forcing the form to submit via AJAX. It is sending a success message for the original form submission setting and again for the AJAX success.
      const originalSuccessHandler = event.freeform._renderSuccessBanner
      if (originalSuccessHandler) {
        event.freeform._renderSuccessBanner = function () {
          // Check if success message already exists
          const existingMessages = form.querySelectorAll('.alert-success, .freeform-success-message')
          if (existingMessages.length > 0) {
            return // Skip render if message already exists
          }
          // Call original handler if no message exists
          return originalSuccessHandler.apply(this, arguments)
        }
      }
    })

    const trackSuccess = () => {
      trackFormSubmission({ formType, brandHandle, pageTitle })
    }

    // Listen for AJAX success events
    document.addEventListener('freeform-ajax-success', (event) => {
      // Check if this event is for our form using event.form property
      if (event.form === form) {
        trackSuccess()
      }
    })
  },
})
